import { BlockDefinition } from "@softr-io/blocks-sdk";

export type PreCompiledBlockDefinition = BlockDefinition & {
    compiled_markup: string;
    compiled_script: string;
    compiled_style: string;
};

export function isPreCompiledBlock(definition: BlockDefinition): definition is PreCompiledBlockDefinition {
    return (
        "compiled_markup" in definition &&
        // pre-compiled blocks have non-empty string value in `compiled_markup` field
        typeof definition.compiled_markup === "string" &&
        definition.compiled_markup !== ""
    );
}
